
    <template>
        <div class="big-container">
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <!-- <v-snackbar v-model="showResult" :timeout="2000" :color="color" top> {{ result }} </v-snackbar> -->

          <div class="container">
            <v-form ref="form" v-model="formValid" lazy-validation>
              <span class="tituloPopUp">Nova Turma </span>
                  <span v-if="idclasse === 1"> - 10ª classe</span>
                  <span v-if="idclasse === 2"> - 11ª classe</span>
                  <span v-if="idclasse === 3"> - 12ª classe</span>
                  <span v-if="idclasse === 4"> - 13ª classe</span>
                  <v-spacer></v-spacer>
              <v-row>
                        <v-col cols="12" sm="8" md="8">
                          <v-select
                            outlined
                            v-model="editedItem.curso"
                            item-text="descricao"
                            @change="createdTurmaflag_description"
                            :items="cursos"
                            chips
                            label="Curso"
                            return-object
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                        <v-select
                            outlined
                            :items="classes"
                            v-model="editedItem.classe"
                            @change="concatTurmaAnolectivo(1)"
                            item-value="id"
                            item-text="descricao"
                            label="Classe"
                            return-object
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="8" md="8">
                        <v-select
                            outlined
                            :items="Listaranoslectivo"
                            v-model="editedItem.anolectivo"
                            @change="concatTurmaAnolectivo(1)"
                            item-value="descricao"
                            item-text="novadescricao"
                            label="Selecione o Ano lectivo"
                            return-object
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <v-text-field
                            outlined
                            :rules="notaRules"
                            v-model="editedItem.sala"
                            label="Sala"
                            @change="concatTurmaAnolectivo(1)"
                          ></v-text-field>
                        </v-col>
                         <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            outlined
                            :rules="notaRules"
                            v-model="editedItem.capacidade"
                            label="Capacidade"
                           ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-select
                            outlined
                            v-model="editedItem.periodo"
                            item-value="value"
                            item-text="descricao"
                            :items="periodos"
                            chips
                            @change="concatTurmaAnolectivo(1)"
                            label="Periodo"
                            return-object
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" >
                          <v-text-field
                            outlined
                            v-model="editedItem.descricao"
                            :rules="[v => !!v || 'campo obrigatório.']"
                            :disabled='!disabledTurmaDescricao'
                            label="Descrição da Turma"
                          ></v-text-field>
                        </v-col>
                      </v-row>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="setRouter('/turma/menu')">Cancel</v-btn>
              <v-btn color="blue darken-1" text  :disabled="!disabledTurmaDescricao" @click="save()">Salvar</v-btn>
            </v-card-actions>
          </div>
        </div>
      </template>
<script>
import axios from '../../../plugins/axios'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  data: () => ({
    dialog: true,
    overlay: false,
    instituicao: ls.get('i_id'),
    turmasClasseAnolectivo: [],
    roles: 'func',
    text: '',
    flag_curso: '',
    formValid: true,
    isLoading: false,
    capacidade: '',
    Listaranoslectivo: [],
    flag_periodo: '',
    flag_sala: '',
    flag_class: '',
    sala: '',
    cursos: [],
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 100) || 'valor da sala invalida',
      v => !!v || 'campo obrigatório.',
      v => !isNaN(v) || 'not number ',
      v => v.length <= 2 || 'valor inválido'
    ],
    periodos: [
      { descricao: 'Manhã', value: 'M', id: 1 },
      { descricao: 'Tarde', value: 'T', id: 2 }
    ],
    classes: [
      { descricao: '10ª', id: 1 },
      { descricao: '11ª', id: 2 },
      { descricao: '12ª', id: 3 },
      { descricao: '13ª', id: 4 }
    ],
    editedIndex: -1,
    editedItem: {
      curso: {
        idCurso: '0',
        descricao: ''
      },
      classe: { descricao: '', id: 0 },
      descricao: '',
      autor: ls.get('idPessoa'),
      periodo: { descricao: '', value: '', id: 0 },
      idinstituicao: '',
      anolectivo: { novadescricao: ls.get('novadescricao'), descricao: ls.get('anolectivo') },
      sala: '',
      capacidade: ''
    },
    defaultItem: {
      curso: {
        idCurso: '0',
        descricao: ''
      },
      classe: { descricao: '', id: 0 },
      descricao: '',
      autor: ls.get('idPessoa'),
      periodo: { descricao: '', value: '', id: 0 },
      idinstituicao: '',
      anolectivo: { novadescricao: ls.get('novadescricao'), descricao: ls.get('anolectivo') },
      sala: '',
      capacidade: ''
    }
  }),

  computed: {
    idclasse () {
      return this.editedItem.classe.id
    },
    disabledTurmaDescricao () {
      return (!!(this.editedItem.periodo.id > 0 && this.editedItem.curso && this.editedItem.sala && this.editedItem.capacidade && this.editedItem.classe.id > 0))
    }
  },

  watch: { },

  created () {
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    this.initializeCursos()
    this.initializeAnosLectivo()
  },

  methods: {
    /** Turmas criadas pela instituicao e adicionadas ao sistema */
    concatTurmaAnolectivo (valor) {
      try {
        if (valor === 1) {
          this.editedItem.descricao = this.flag_curso
            .trim()
            .toUpperCase()
            .substring(0, 3)
            .concat('-')
            .concat('SALA ' + this.editedItem.sala.padStart(2, '0') + '-')
            .concat(this.editedItem.periodo.value + '-' + this.editedItem.anolectivo.novadescricao)
        }
      } catch (error) {
      }
    },

    createdTurmaflag_description () {
      this.flag_curso = this.editedItem.curso.descricao
      this.concatTurmaAnolectivo(1)
    },
    async initializeCursos () {
      try {
        //
        this.cursos = await axios.get('/cursoFindAll').then(res => res.data)
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro'
        })
      }
    },

    async initializeAnosLectivo () {
      try {
        this.isLoading = true
        this.Listaranoslectivo = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro'
        })
      } finally {
        this.isLoading = false
      }
    },
    async save () {
      if (this.$refs.form.validate()) {
        let turma = this.flag_curso.trim()
          .toUpperCase()
          .substring(0, 3)
          .concat('-')
          .concat('SALA ' + this.editedItem.sala.padStart(2, '0') + '-')
          .concat(this.editedItem.periodo.value + '-' + this.editedItem.anolectivo.novadescricao)
        if (turma !== this.editedItem.descricao) {
          turma = this.editedItem.descricao.concat('-')
            .concat('SALA ' + this.editedItem.sala.padStart(2, '0') + '-')
            .concat(this.editedItem.periodo.value + '-' + this.editedItem.anolectivo.novadescricao)
        }

        try {
          let params = {
            idCurso: this.editedItem.curso.idCurso,
            idAno_Academico: this.idclasse,
            descricao: turma,
            autor: ls.get('idPessoa'),
            periodo: this.editedItem.periodo.descricao,
            sala: this.editedItem.sala,
            capacidade: this.editedItem.capacidade,
            anolectivo: this.editedItem.anolectivo.descricao
          }
          this.overlay = true
          let corMensagem = ''
          let msg = await axios
            .post('/turmaInsertOne', params)
            .then(res => res.data)
          // verificação da mensagem  de erro
          if (msg === 'Turma ja existente') {
            this.text = 'Turma ja existente'
            Swal.fire({
              icon: 'warning',
              title: '',
              text: 'Turma existente'
            })
          } else
          if (msg.length) {
            Swal.fire({
              icon: 'error',
              title: '',
              text: 'Ocorreu um erro ao tentar efectuar a operação'
            })
          } else {
            this.$refs.form.reset()
            this.editedItem = this.defaultItem
            Swal.fire({
              icon: 'success',
              title: '',
              text: 'Operação efectuada com sucesso.'
            })
          }
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: '',
            text: 'Ocorreu um erro'
          })
        }

        this.overlay = false
      } else {
        Swal.fire({
          icon: 'warning',
          title: '',
          text: 'Preencha correctamente o(s) campo(s)'
        })
      }
    },
    setRouter (router) {
      this.$store.state.fromMenu = 'gestao'
      this.$router.push(router)
    }
    //* ********************************************************************************************* */
    // END METHOD FOR VAL
  }
}
</script>
<style scoped>
.big-container {
  height: 100%;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(196, 195, 195, 0.5);
}

.tituloPopUp {
  text-align: center;
  display: block;
  font-size: 18px;
  font-weight: 500;
}

.container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  background-color: #fff;
  border: 0.1px solid #c2c2dd;
  padding: 20px;
  font-size: 12px;
  font-family: sans-serif;
}
</style>
